var map = {
	"./1.png": 1165,
	"./2.png": 1166,
	"./3.png": 1167,
	"./4.png": 1168,
	"./5.png": 1169,
	"./6.png": 1170,
	"./7.png": 1171,
	"./8.png": 1172,
	"./avatar/1.png": 571,
	"./avatar/2.png": 572,
	"./avatar/3.png": 573,
	"./avatar/4.png": 574,
	"./avatar/5.png": 575,
	"./avatar/6.png": 576,
	"./avatar/7.png": 577,
	"./avatar/8.png": 578,
	"./ei_board.png": 418,
	"./ei_example.png": 420,
	"./ei_step.png": 419,
	"./scenario.png": 181
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 570;